import React from "react";
import { X, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const TINT = {
  sapphire: { text: "#6B9EE8", border: "rgba(15, 82, 186, 0.35)", glow: "rgba(15, 82, 186, 0.18)" },
  ruby:     { text: "#E86B8C", border: "rgba(224, 17, 95, 0.35)", glow: "rgba(224, 17, 95, 0.16)" },
  emerald:  { text: "#6BE895", border: "rgba(80, 200, 120, 0.35)", glow: "rgba(80, 200, 120, 0.16)" },
};

export const CountryPickerModal = ({ open, onClose, gemType, onSelectCountry }) => {
  const { t, lang } = useLang();
  if (!open || !gemType) return null;
  const tint = TINT[gemType] || TINT.sapphire;
  const origins = t.origins[gemType] || [];
  const heading = t.gems[gemType];

  return (
    <div
      data-testid="country-picker-modal"
      className="fixed inset-0 z-50 flex items-start justify-center p-4 md:p-8 bg-black/85 backdrop-blur-md overflow-y-auto"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-xl my-8 rounded-sm bg-[#050B1E] border p-6 md:p-8"
        style={{ borderColor: tint.border, boxShadow: `inset 0 0 120px ${tint.glow}` }}
      >
        <button
          data-testid="picker-close-btn"
          onClick={onClose}
          className="absolute top-4 right-4 text-[#A1A7B3] hover:text-[#F8F5EE] transition-colors z-10"
          aria-label={t.modal.close}
        >
          <X size={22} strokeWidth={1.4} />
        </button>

        <div className="mb-6">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#C1A661]">
            {heading}
          </div>
          <h2 className="mt-1 font-serif text-2xl md:text-3xl font-light text-[#F8F5EE] leading-tight tracking-wide">
            {lang === "fr" ? "Choisissez un pays d'origine" : "Choose a country of origin"}
          </h2>
          <p className="mt-2 text-[12px] text-[#A1A7B3] font-light">
            {lang === "fr"
              ? "Cliquez sur un pays pour consulter sa fiche complète et sa grille tarifaire."
              : "Click a country to open its full fact sheet and pricing grid."}
          </p>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {origins.map((o) => (
            <li key={o}>
              <button
                data-testid={`picker-${gemType}-${o.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
                onClick={() => onSelectCountry(o)}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-sm border text-left transition-colors hover:brightness-125"
                style={{ borderColor: tint.border, backgroundColor: "rgba(5,8,17,0.6)" }}
              >
                <MapPin size={14} strokeWidth={1.5} style={{ color: tint.text }} />
                <span className="text-[13px] text-[#E2CFA4] font-light tracking-wide">{o}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
